import { useTranslation } from 'next-i18next'
import NewShell from './NewShell'
import ContactHero from './contact-new/ContactHero'
import ContactInfoCards from './contact-new/ContactInfoCards'
import ContactMapSection from './contact-new/ContactMapSection'

// NEW-design (?new) variant of pages/contact.js — full redesign built to the
// contact-us mockup (new-design-other/contactus/single.png). Content model
// matches the old /contact page (info cards + map, no contact form) per
// product decision — only the chrome/visual design changes. The old
// /contact page (no ?new) keeps its own inline content untouched via the
// guard in pages/contact.js. All chrome (HeaderNew + FooterNew + Sukhumvit
// webfont) comes from NewShell.
const ContactNew = () => {
  const { t } = useTranslation('contact-us')
  return (
    <NewShell
      title={t('new.meta.title')}
      keywords={t('new.meta.keywords')}
      description={t('new.meta.description')}
    >
      <ContactHero />
      <ContactInfoCards />
      <ContactMapSection />
    </NewShell>
  )
}

export default ContactNew
